import { $$ } from './utils';
import { Fancybox } from '@fancyapps/ui';
import { reachMetrikaGoal } from './variables';
// import '@fancyapps/ui/dist/carousel/carousel.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
// import '@fancyapps/ui/dist/carousel/carousel.thumbs.css';
const fancy = (selectors) => {
    Fancybox.bind('[data-fancybox]', {
        animated: false,
        compact: true,
        idle: false,
        Carousel: {
            transition: 'classic',
            friction: 0.12,
        },
    });
    Fancybox.bind('[data-fancybox="gallery-product"]', {
        on: {
            // TST-028: открытие фото товара на карточке
            init: () => reachMetrikaGoal('GALLERY_OPEN'),
        },
        compact: false,
        idle: false,
        animated: true,
        showClass: false,
        hideClass: false,
        dragToClose: false,
        contentClick: false,
        Images: {
            // Disable animation from/to thumbnail on start/close
            zoom: false,
        },
        Carousel: {
            transition: 'classic',
            friction: 0.12,
        },
    });
    selectors.forEach(item => {
        $$(`.${item.trigger}`).forEach((trigger) => {
            const form = document.querySelector(`#${item.form}`);
            const header = form.querySelector('.modal-form__title__header');
            const desc = form.querySelector('.modal-form__title__desc');
            trigger.on('click', (event) => {
                event.preventDefault();
                // Изменить модальное окно 
                header ? header.innerHTML = item.header : '';
                if (desc) {
                    if (item.desc) {
                        desc.classList.remove('hide');
                        desc.innerHTML = item.desc;
                    }
                    else {
                        desc.classList.add('hide');
                    }
                }
                // Показать модальное коно с формой
                Fancybox.show([{
                        src: `#${item.form}`
                    }]);
                // TST-028: открытие формы «Заказать» на карточке прицепа
                if (item.form === 'order_form') {
                    reachMetrikaGoal('ORDER_FORM_OPEN');
                }
            });
        });
    });
};
export default fancy;
